<a #resultLink (click)="suggestClick($event);" href="{{ uri }}">
    {{title}} <small *ngIf="result" class="suggest-meta">{{ result.type }}</small>
</a>